import React, { useState } from 'react';
import Drawer from './Drawer';
import ClientFormFields, { emptyClientForm } from './ClientFormFields';
import { Button } from './ui/button';
import { clientsService } from '../services/salesService';
import { useToast } from '../contexts/ToastContext';

function ClientQuickCreateModal({ open, onClose, onCreated }) {
    const { toast, toastApiError } = useToast();
    const [formData, setFormData] = useState(emptyClientForm());
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSave = async () => {
        if (loading) return;
        setLoading(true);
        try {
            const response = await clientsService.create(formData);
            const created = response.data?.data || response.data;
            toast({ title: 'Cliente criado', description: 'Cadastro realizado com sucesso', variant: 'success' });
            setFormData(emptyClientForm());
            onCreated?.(created);
            onClose?.();
        } catch (e) {
            console.error('Error creating client:', e);
            toastApiError(e, { title: 'Erro ao salvar', fallback: 'Não foi possível salvar o cliente' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Drawer
            open={open}
            onClose={onClose}
            title="Novo cliente"
            size="md"
            footer={
                <div className="flex justify-end gap-3">
                    <Button type="button" variant="outline" onClick={onClose}>
                        Cancelar
                    </Button>
                    <Button type="button" onClick={handleSave} disabled={loading}>
                        {loading ? 'Salvando...' : 'Salvar'}
                    </Button>
                </div>
            }
        >
            <ClientFormFields formData={formData} onChange={handleChange} />
        </Drawer>
    );
}

export default ClientQuickCreateModal;
